<!-- Carrito Amena -->
<!---------------------->
<div id="shopping-cart" class="sidenav" *ngIf="getShoppingCart() !== undefined">
    <div class="sidebar-header">
        <a class="closebtn">
            <img src="./assets/img/times.svg" class="img-fluid icon-close" width="17" (click)="closeCart()">
        </a>
        <h1 class="mb-2" align="center">
            <b>Resumen</b>
        </h1>
    </div>

    <ng-container *ngFor="let item of getShoppingCart().getItems(); index as itemIndex">
        <!-- PRODUCTO CONTRATADO -->
        <!------------------------->
        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <h6 class="resumen-color">
                <b>{{ item.stepper_index === firstItem ? itemTittle : 'Linea móvil adicional'}}</b>
            </h6>
            <span class="d-flex justify-content-end align-items-center">
                <small class="text-muted trash-carrito">
                    <!-- editar producto -->
                    <a (click)="goToStep(item.stepper_index)">
                        <img src="./assets/img/edit.svg" class="img-fluid icon-nav-sidebar" width="15">
                    </a>
                </small>
                <small class="text-muted trash-carrito" *ngIf="item.stepper_index !== firstItem">
                    <!-- editar producto -->
                    <a (click)="removeExtraLine(itemIndex)" class="ps-2">
                        <img src="./assets/img/trash.svg" class="img-fluid icon-nav-sidebar" width="15">
                    </a>
                </small>
            </span>
        </div>

        <!-- INFO GENERAL -->
        <h6 class="info-nav-sidebar" *ngIf="item.stepper_index === firstItem && item.stepper_index">
            <span class="sidebar-info" *ngIf="itemIndex === 0">
                <img src="./assets/img/map-pin2.svg" class="img-fluid" width="13">
                Dirección de instalación
                <br>
                <b>{{ getShoppingCart().getAddress() }}</b>
            </span>
        </h6>
        <!-- Fijo a portar -->
        <h6 class="info-nav-sidebar" *ngIf="item.stepper_index === firstItem && item.stepper_index && infoFijo && infoFijo.get('tipoAltaFijo').value && infoFijo.get('tipoAltaFijo').value !== ''">
            <span class="sidebar-info">
                <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                {{ infoFijo.get('tipoAltaFijo').value === 'registration' ? 'Alta línea fija' : ((infoFijo.get('tipoAltaFijo').value === 'migration' ? 'Línea fija a migrar ' : 'Línea fija a portar ') + infoFijo.get('portabilidadFijo').value) }}
            </span>
        </h6>
        <!-- Teléfono a portar -->
        <h6 class="info-nav-sidebar" *ngIf="getShoppingCart().getOperation().getItemForms()[itemIndex]">
            <span class="sidebar-info">
                <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                {{ (getShoppingCart().getOperation().getItemForms()[itemIndex].get('type_operation').value === 'registration' || getShoppingCart().getOperation().getItemForms()[itemIndex].get('type_operation').value === 'registration_logistica') ? 'Alta línea móvil' : ((getShoppingCart().getOperation().getItemForms()[itemIndex].get('type_operation').value === 'migration' ? 'Línea móvil a migrar ' : 'Línea móvil a portar ') + getShoppingCart().getOperation().getItemForms()[itemIndex].get('portability_phone').value) }}
            </span>
        </h6>

        <div *ngFor="let concept of item.concepts"
             class="resumen d-flex justify-content-between align-items-center">
            <!--TERMINALES Y TARIFAS CON COSTE MENSUAL-->
            <ng-container *ngIf="concept.monthlyCost > 0 || (concept.monthlyCost == 0 && concept.initialCost == 0)">
                <!-- concepto -->
                <span class="sidebar-info5" [ngSwitch]="concept.type">
                    <ng-container *ngSwitchCase="'rate'">
                        <!-- <img src="./assets/img/package2.svg" class="img-fluid" width="13">{{concept.type_operation === 'registration' ? 'Alta teléfono fijo' : 'Portabilidad teléfono fijo' }}<br> -->
                        <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                        {{ concept.desc }} ({{ concept.speed && concept.speed !== '' ? concept.speed + ' + ' + concept.data : concept.data }})
                        <span *ngIf="concept.months !== '' && concept.months !== null && concept.months !== undefined">
                            ({{concept.months}} meses)
                        </span>
                    </ng-container>

                    <ng-container *ngSwitchCase="'terminal'">
                        <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13">
                        {{ concept.desc }}
                        <span *ngIf="concept.months !== '' && concept.months !== null && concept.months !== undefined">
                            <br>
                            ({{concept.months}} meses)
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'other'">
                        <img src="./assets/img/layers.svg" class="img-fluid" width="13">
                        {{ concept.desc }}
                        <span *ngIf="concept.months !== '' && concept.months !== null && concept.months !== undefined">
                            ({{concept.months}} meses)
                        </span>
                    </ng-container>
                </span>
                <small class="text-muted">
                    <!-- Precio concepto -->
                    <span class="sidebar-info3">
                        <b>
                            {{ concept.monthlyCost | currency:'EUR':'' }}€
                            <span *ngIf="concept.monthlyCost != 0">/mes</span>
                        </b>
                    </span>
                </small>
            </ng-container>
            <!--TERMINALES AL CONTADO ASOCIADO A SU TARIFA-->
            <ng-container *ngIf="concept.monthlyCost == 0 && concept.initialCost > 0">
                <!-- concepto -->
                <span class="sidebar-info5" [ngSwitch]="concept.type">
                    <ng-container *ngSwitchCase="'terminal'">
                        <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13">
                        {{ concept.desc }}
                        <span> </span>
                    </ng-container>
                </span>
                <small class="text-muted">
                    <span class="sidebar-info3">
                        <b>
                            {{ concept.paymentType === 'unico' ? 'Pago único' : ''}}
                        </b>
                    </span>
                </small>
            </ng-container>
        </div>
        <br>

        <div class="resumen d-flex justify-content-between align-items-center mt-2">
            <span class="sidebar-info"><b>Total</b></span>
            <small class="text-muted trash-carrito">
                <!-- Precio tarifa -->
                <span class="sidebar-info2"><b>{{ getShoppingCart().conceptsMonthlySubtotal(item.concepts) | currency:'EUR':'' }} €/mes</b></span>
            </small>
        </div>
        <!-- ./PRODUCTO CONTRATADO -->
        <!--------------------------->
        <br>
    </ng-container>

    <ng-container>
        <div class="resumen d-flex justify-content-between align-items-center" *ngIf="router !== '/amena/solo_movil' && getShoppingCart().getMonthlyDiscount() > 0">
            <span class="sidebar-info">Descuento <b>líneas adicionales</b></span>
            <small class="text-muted trash-carrito">
                <span class="sidebar-info2">
                    <b>-{{ getShoppingCart().getMonthlyDiscount() | currency:'EUR':''}} €/mes</b>
                </span>
            </small>
        </div>
        <!-- Importe Total -->
        <div class="resumen-total total d-flex justify-content-between align-items-center" *ngIf="getShoppingCart().getMonthlyTotal() > 0">
            <h5 class="total-color">
                <b>Pago mensual</b>
            </h5>
            <h5 class="text-auto">
                <b *ngIf="router === '/amena/solo_movil'">{{ getShoppingCart().getMonthlyTotal() | currency:'EUR':'' }} €/mes</b>
                <b *ngIf="router !== '/amena/solo_movil'">{{ getShoppingCart().getMonthlyTotalWithDiscount() | currency:'EUR':'' }} €/mes</b>
            </h5>
        </div>
    </ng-container>

    <ng-container *ngIf="getShoppingCart().hasItems() || terminalDelivery != null">
        <br>
        <hr class="line-a">
        <br>
        <div class="resumen d-flex justify-content-between align-items-center" *ngFor="let concept of getShoppingCart().getConceptsWithInitialCost()">
            <span class="sidebar-info" [ngSwitch]="concept.type">
                <ng-container *ngSwitchCase="'rate'">
                    <img src="./assets/img/package2.svg" class="img-fluid" width="13"> {{ concept.desc }}1
                </ng-container>
                <ng-container *ngSwitchCase="'terminal'">
                    <img src="./assets/img/smartphone2.svg" class="img-fluid" width="13"> {{ concept.desc }} {{ concept?.paymentType === 'unico' ? '(Pago único)' : '' }}
                </ng-container>
                <ng-container *ngSwitchCase="'other'">
                    <img src="./assets/img/layers.svg" class="img-fluid" width="13"> {{ concept.desc }}3
                </ng-container>
            </span>
            <small class="text-muted trash-carrito">
                <!-- Importe sin IVA -->
                <span class="sidebar-info2">
                    <b>{{ concept.initialCost | currency:'EUR':'' }} €</b>
                </span>
            </small>
        </div>

        <div class="resumen d-flex justify-content-between align-items-center" *ngIf="terminalDelivery">
            <span class="sidebar-info">
                <ng-container>
                    <img src="./assets/img/layers.svg" class="img-fluid" width="13"> {{ getTerminalDeliveryTitle() }}
                </ng-container>
            </span>
            <small class="text-muted trash-carrito">
                <!-- Importe sin IVA -->
                <span class="sidebar-info2">
                    <b>{{ terminalDelivery.deliveryPrice | currency:'EUR':'' }} € {{ getShoppingCart().getLogisticaItems() > 1 ? (' x ' + getShoppingCart().getLogisticaItems() + '*') : '' }}</b>
                </span>
            </small>
        </div>

        <div class="resumen d-flex justify-content-between align-items-center" *ngIf="terminalDelivery && getShoppingCart().getLogisticaItems() > 1">
            <span class="sidebar-info">
                <ng-container>
                    *Líneas con envío por logística
                </ng-container>
            </span>
        </div>

        <!-- Importe al contado -->
        <div class="resumen-total total d-flex justify-content-between align-items-center" *ngIf="getShoppingCart().getConceptsWithInitialCost().length > 0 || terminalDelivery != null">
            <h5 class="total-color">
                <b>Pago inicial</b>
            </h5>
            <h5 class="text-auto verde">
                <b>{{ getShoppingCart().getInitialTotal() | currency:'EUR':'' }} €</b>
            </h5>
        </div>

        <div class="info-nav-sidebar" *ngIf="cartAgreements && cartAgreements !== '' && cartAgreements.show">
            <span class="sidebar-info">
                <b>Importes a añadir en tu última factura Orange:</b>
            </span>
            <br>
            <li class="sidebar-info mt-0" *ngIf="cartAgreements.cp_price > 0">
                {{ cartAgreements.cp_price }} € por penalización CP línea móvil
            </li>
            <br *ngIf="cartAgreements.cp_price > 0">
            <li class="sidebar-info mt-0" *ngIf="cartAgreements.terminals && cartAgreements.terminals.length">
                {{ cartAgreements.vap_price }} € en cuotas del terminal pendientes
            </li>            
        </div>
        
        <div class="resumen-total total d-flex justify-content-between align-items-center">
            <span class="total-color">
                <b>IVA incluido</b>
            </span>
        </div>
        <br>
        <!--
        <div class="resumen d-flex justify-content-between align-items-center">
            <span class="sidebar-info">Importe sin <b>IVA</b></span>
            <small class="text-muted trash-carrito">-->
        <!-- Importe sin IVA -->
        <!-- <span class="sidebar-info2"><b>{{getShoppingCart().getWithoutIVA(getShoppingCart().getMonthlyTotal() + getShoppingCart().getInitialTotal()) | currency:'EUR':''}} €/mes</b></span>
        </small>
    </div>-->

        <!-- Importe Total -->
        <!-- <div class="resumen-total total d-flex justify-content-between align-items-center">
             <h5 class="total-color"><b>total</b></h5>
             <h5 class="text-auto"><b>{{ getShoppingCart().getMonthlyTotal() + getShoppingCart().getInitialTotal() | currency:'EUR':'' }} €/mes</b></h5>
         </div>-->
    </ng-container>
    <ng-container *ngIf="(getShoppingCart().getInitialTotal() == 0 ) && (getShoppingCart().getMonthlyTotal() == 0)">
        <div class="container">
            <p class="py-4">Todavía no se han añadido servicios al pedido.</p>
        </div>
    </ng-container>

    <button *ngIf="!enviroment.production" (click)="logOperation()">(debugmode) Show operation in console</button>

</div>
<!-- ./ Carrito Amena ----->
<!------------------------->
